import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { DirectoryListingParams, DocumentRevision } from '@/entities/Document';

export async function getModuleContent(
  moduleId: number,
  params: DirectoryListingParams
): Promise<ApiResponse<DocumentRevision[]>> {
  const response = await api.get<ApiResponse<DocumentRevision[]>>(`/modules/${moduleId}`, {
    params,
  });
  return response.data;
}
